export const searchOptions = [
  { value: '/specials', label: 'All' },
  { value: '/lessons', label: 'Lessons' },
  { value: '/packages', label: 'Packages' },
  { value: '/bands', label: 'Artists' }
];
